export const contentNodFound = {
  marginTop: {
    xs: '0rem', sm: '0rem', md: '6.5rem', lg: '6.5rem', xl: '6.5rem',
  },
  marginBottom: {
    xs: '207px', sm: '207px', md: '273px', lg: '273px', xl: '273px',
  },
  padding: '0px',
};
